import FileAttachments from "./FileAttachments";
import VacSelection from "./VacSelection";
import { sitesForSub } from "./checklistData";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Map, Globe, ExternalLink } from "lucide-react";

export default function NavMapTab({ briefing, setBriefing, briefingId, onExportVac, exporting }) {
  const SiteLinks = ({ subId }) => {
    const sites = sitesForSub(briefing, subId);
    if (!sites.length) return null;
    return (
      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-cyan-500/70"><Globe className="h-3 w-3" /> Sites</span>
        {sites.map((s) => (
          <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-[11px] text-cyan-400 hover:underline">
            {s.name} <ExternalLink className="h-3 w-3" />
          </a>
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-5">
      <div className="glass rounded-2xl p-6">
        <h3 className="mb-4 flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-wide text-cyan-400">
          <Map className="h-4 w-4" /> Carte de navigation
        </h3>
        <p className="mb-4 text-xs text-slate-500">
          Collez (Ctrl/Cmd+V), glissez ou téléversez le visuel de votre carte (tracé, points tournants, espaces…). Aucune carte OACI propriétaire n'est fournie — utilisez votre propre visuel.
        </p>
        <FileAttachments briefingId={briefingId} pointId="navmap" title="Visuel de la carte" />
        <SiteLinks subId="navmap" />
      </div>

      <VacSelection briefing={briefing} setBriefing={setBriefing} briefingId={briefingId} onExportVac={onExportVac} exporting={exporting} />
      <SiteLinks subId="vac" />

      <div className="glass rounded-2xl p-6">
        <Label className="text-[11px] uppercase tracking-wider text-slate-400">Commentaire de la carte</Label>
        <Textarea value={briefing.navMapComment || ""} data-testid="navmap-comment"
          onChange={(e) => setBriefing((b) => ({ ...b, navMapComment: e.target.value }))}
          rows={4} placeholder="Décrivez la carte : tracé, points tournants, altitudes, zones traversées, points de report…"
          className="mt-1.5 border-slate-700 bg-slate-900/60 text-slate-100" />
      </div>
    </div>
  );
}
